import React from "react";
import Card from "react-bootstrap/Card";
import { ImCircleRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify"  }}>
          Hello, I am<span className="purple"> <b>Avdhesh Kumar Singh</b>  </span>
          from <span className="purple"> <b> Delhi, India.</b></span>
          <br />
          I am a final year B.Tech student from the Department of <span className="purple"> <b>Information Technology</b></span> at Delhi Technological University, Delhi.
          <br>
          </br>
          As a student and learner with a keen interest in the world of <span className="purple"> <b>software development</b></span> and the immense opportunities it offers.
          I am poised to embark on a fulfilling career in this ever-evolving industry. 
          <br>
          </br>
          <br>
          </br>
          As a <span className="purple"> <b>young programmer</b></span>, I am filled with <span className="purple"> <b>curiosity</b></span>,<span className="purple"> <b>enthusiasm</b></span>, and a deep <span className="purple"> <b>passion</b></span> for the world of<span className="purple"> <b>coding</b></span>.
          I embrace the challenges that come ahead, seeing them as opportunities to expand my <span className="purple"> <b> knowledge</b></span> and <span className="purple"> <b>  skill set</b></span>.
          <br>
          </br>
          I am committed to making a  <span className="purple"> <b>positive impact</b></span> through my dedication, creativity, and technical expertise .
          Being new to <span className="purple"> <b>professional programming</b></span> gives me a fresh perspective, free from preconceived notions or rigid thinking patterns.
          <br>
          </br>
          <br>
          </br>
          
          I believe that Challenges are not <span className="purple"> <b> obstacles</b></span> but<span className="purple"> <b> opportunities</b></span> for expanding knowledge base and skills set         
          along with  that I am excited to contribute my skills and expertise to projects that challenge me and push the boundaries of what is possible in the tech field.
            <br />
           
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImCircleRight /> Reading books
            </li>
            <li className="about-activity">
              <ImCircleRight /> Pencil Sketching
            </li>
            <li className="about-activity">
              <ImCircleRight />  Listening music 
            </li>
          </ul>

          <p style={{ color: " rgb(195, 211, 20) " }}>
            "Investment in knowledge pays the best interest "{" "}
          </p>
          <footer className="blockquote-footer">Benjamin Franklin
</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;



 

